import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import NewDisclaimer from 'apps/auth/components/send/disclaimers/NewDisclaimer';
import CashPickupLocationsPopup from 'apps/auth/components/send/popups/CashPickupLocationsPopup';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const UnitellerConfirmationPopup = (props) => {
    const {
        popupRef,
        modalRef,
        closeHandlerForPopup,
        messages: { gotIt, gotItButton, unitellerCashPickupGuideButton, unitellerPickUpGuid, unitellerPickUpGuidWorkingHours, textDelivery },
    } = props;
    const onCloseClick = (e) => {
        e?.preventDefault?.();
        modalRef?.current?.close();
        popupRef?.current?.open(<UnitellerConfirmationPopup {...props} />);
    };
    return (
        <SimplePopup
            popupRef={popupRef}
            text={MarkdownService.splitByParagraph(unitellerPickUpGuid || '', [textDelivery, unitellerPickUpGuidWorkingHours])}
            handleClose={closeHandlerForPopup}
            withoutCloseButton
        >
            <PopupButton
                iconName="arrow-forward"
                target="_blank"
                text={unitellerCashPickupGuideButton}
                onClick={(e) => {
                    e?.preventDefault();
                    popupRef?.current?.close();
                    modalRef?.current?.open(
                        <NewDisclaimer
                            onCloseClick={onCloseClick}
                            clickAgree={onCloseClick}
                            detailsClick={(e) => {
                                e?.preventDefault?.();
                                popupRef?.current?.open(<CashPickupLocationsPopup popupRef={popupRef} />);
                            }}
                            recipientType={props.recipientType}
                            paymentMethod={props.paymentMethod}
                        />,
                    );
                }}
            />
            <PopupButton iconName="check" title={gotIt} text={gotItButton} onClick={closeHandlerForPopup} />
        </SimplePopup>
    );
};
export default UnitellerConfirmationPopup;
